module.exports = __webpack_public_path__ + "media/TypingFuture.1becc634.wav";